export const pharmaciesRoutes = {
  'route.pharmacies.index': '/services/online-pharmacy',
  'route.pharmacies.otc': '/services/online-pharmacy/pharmacies-otc',
  'route.pharmacies.upload-prescription': '/services/online-pharmacy/pharmacies-upload-prescription',
  'route.pharmacies.electronic-prescription': '/services/online-pharmacy/pharmacies-electronic-prescription',
  'route.pharmacies.checkout-upload': '/services/online-pharmacy/pharmacies-upload-prescription/checkout',
  'route.pharmacies.checkout-otc': '/services/online-pharmacy/pharmacies-otc/checkout',
  'route.pharmacies.checkout-electronic-prescription': '/services/online-pharmacy/pharmacies-electronic-prescription/checkout',

  'api.pharmacies.store': 'pharmacies/data',
  'api.pharmacies.upload-file': 'upload/[sectionType]/[year]/[month]/[day]/[time]/[type]/file',
  'api.pharmacies.drug-list': 'pharmacies/data/[order_reference_id_affix]/drug-list',
  'api.pharmacies.invoice': 'pharmacies/data/show-status/[id]',
  'api.pharmacies.check-drug': 'pharmacies/check-drug',
  'api.pharmacies.insurance-list': 'pharmacies/get-insurance',
};
